module.exports = __webpack_public_path__ + "img/staff-brad-hinds.e3b649f2.png";